<template>
  <div>
    <v-list dense>
      <v-list-item
        link
        @click="findFile"
      >
        <v-list-item-avatar>
          <Icon
            :width="24"
            :color="$vuetify.theme.themes.dark.primary"
            :icon="'paperclip'"
          />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{$t('uploadOptions.internalFiles')}}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{$t('uploadOptions.exploreFiles')}}
          </v-list-item-subtitle>
          <input
            ref="file-uploader"
            class="d-none"
            type="file"
            @change="selectFile"
          >
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'


@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class UploadOptions extends Vue {
  data () {
    return {
      file: {
        attachment: null,
        name: null,
      }
    }
  }

  clear () {
    file.attachment = null
    file.name = null
  }

  findFile() {
    window.addEventListener('focus', () => {}, { once: true })
    this.$refs['file-uploader'].click()
  }

  selectFile(e) {
    this.file.attachment = e.target.files[0]
    this.file.name = e.target.files[0].name
    const reader  = new FileReader()

    reader.onloadend = () => {
      this.$emit('setPreview', reader.result, this.file)
    }

    reader.readAsDataURL(this.file.attachment)
  }
}
</script>

<style>
.pointer {
  cursor: pointer !important;
}
</style>
